import { ActionType, UPDATE_CHAT_MESSAGES, UPDATE_NEW_MESSAGES_COUNTER, 
    SET_TWILIO_CLIENT_INITIALIZED, ADD_NEW_MESSAGE, MESSAGES_RECEIVED } from '../actions/chat'
import Message from 'twilio-chat/lib/message'
import { ChatMessage } from '../types/ChatMessage';

export interface ChatState {
    twilioToken: string
    messages: ChatMessage[]
    isInReplyMode: boolean,
    replyToSid: string,
    newMessagesCounter:number,
    isTwilioClientInitialized: boolean,
    isMessagesReceived: boolean
}

const initialState: ChatState = {
    twilioToken: '',
    messages: new Array(),
    isInReplyMode: false,
    replyToSid: '',
    newMessagesCounter: 0,
    isTwilioClientInitialized: false,
    isMessagesReceived: false
}

export function chatReducer (state: ChatState = initialState, action: ActionType) {
    switch (action.type) {
        case UPDATE_CHAT_MESSAGES: {
            return {
                ...state,
                messages: action.payload
            }
        }
        case UPDATE_NEW_MESSAGES_COUNTER:{
            return{
                ...state, 
                newMessagesCounter: action.payload
            }
        }
        case SET_TWILIO_CLIENT_INITIALIZED:{
            return{
                ...state, 
                isTwilioClientInitialized: action.payload
            }
        }
        case ADD_NEW_MESSAGE:{
            //twilio message listner bug workaround, fix later
            let index = state.messages.findIndex(msg => {
                return msg.sid == action.payload.sid
            })
            console.log('index', index)
             let newArray = index == -1 ? Array.concat(state.messages, new Array(action.payload)) : state.messages
             let counter = index == -1 ? ++state.newMessagesCounter : state.newMessagesCounter
            return{
                ...state,
                messages:newArray,
                newMessagesCounter: counter
            }
        }
        case MESSAGES_RECEIVED:{
           return{
               ...state,
               isMessagesReceived: action.payload
           }
       }
        default: return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/chat.ts